import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Calendar } from "lucide-react";
import api from "../../lib/api";

export default function UpdatesFeed() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/updates").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  if (!items.length) return null; // hide entirely if no updates

  return (
    <section className="py-20 md:py-28 bg-[#F5F2EB]" data-testid="updates-feed">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 md:mb-16">
          <div className="max-w-xl">
            <p className="overline text-[#B08858]">From our studio</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] mt-3 text-[#0A0A0A]">
              The latest from Theo-Oppolia.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 6).map((u, i) => {
            const Card = (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.05 }}
                className="bg-white border border-[#D7CFC4] hover:border-[#B08858]/40 transition group h-full flex flex-col"
                data-testid={`update-card-${u.id}`}
              >
                {u.image_url && (
                  <div className="aspect-[4/3] overflow-hidden bg-[#F5F2EB]">
                    <img
                      src={u.image_url}
                      alt=""
                      width="1200"
                      height="900"
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover transition duration-700 group-hover:scale-[1.04]"
                    />
                  </div>
                )}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-xs text-[#0A0A0A]/40 mb-3">
                    <Calendar size={12} />
                    <time>{new Date(u.created_at).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" })}</time>
                  </div>
                  <h3 className="font-display text-2xl leading-tight text-[#0A0A0A]">{u.title}</h3>
                  <p className="mt-3 text-sm text-[#0A0A0A]/70 leading-relaxed flex-1 whitespace-pre-line">
                    {u.body}
                  </p>
                  {u.link_url && (
                    <span className="inline-flex items-center gap-1 mt-4 text-xs uppercase tracking-[0.18em] text-[#B08858] group-hover:gap-2 transition-all">
                      Read more <ArrowUpRight size={12} />
                    </span>
                  )}
                </div>
              </motion.div>
            );
            return u.link_url ? (
              <a key={u.id} href={u.link_url} target="_blank" rel="noopener noreferrer">{Card}</a>
            ) : (
              <div key={u.id}>{Card}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
